import classNames from 'classnames'

import style from './style.scss'

type Props = {
  className?: string
  iconLabelText: string
  title?: string
  url: string
  variant?: 'light' | 'dark'
}

function EmailSharingIcon({
  className,
  iconLabelText,
  url,
  title = '',
  variant = 'dark',
}: Props) {
  const subject = encodeURI(`CrossFit.com: ${title}`)
  const body = encodeURI(url)
  const mailLink = `mailto:?subject=${subject}&body=${body}`

  return (
    <a
      className={classNames(
        style.wrapper,
        variant && style[variant],
        className,
      )}
      href={mailLink}
    >
      <span>{iconLabelText}</span>
    </a>
  )
}

export default EmailSharingIcon
